// features/databox
import getForwardRoutes from "./getForwardRoutes";

// A ---------------------------------------------------------------------- M

const getTargetsData = async (databoxID) => {
  try {
    const targetsArray = await getForwardRoutes(databoxID);
    const enabledTargetsCount = targetsArray.filter((target) => target.enabled).length;

    return {
      targetsArray,
      enabledTargetsCount,
    };
  } catch (error) {
    console.error("Error in getTargets:", error);
    return {
      targetsArray: [],
      enabledTargetsCount: 0,
    };
  }
};

export default getTargetsData;
